<template>
  <div class="relative header" :class="className">
    <Menu />
    <div class="background_video">
      <video src="/videos/animation_piranha.mp4" autoplay loop class="full-width full-height"></video>
    </div>
    <div class="container column items-center center">
      <router-link :to="{name: 'home'}">
        <div class="logo-container mb1">
          <img src="/images/logo.png" alt="logo" />
        </div>
      </router-link>
      <div class="caps bold subtitle_banner mt1 white">{{$store.state.translations.sous_titre}}</div>
      <h1 class="caps mt4 black italic white h1-header">{{$store.state.translations.titre_accueil}}</h1>
      <div class="arrow-parent">
        <a v-if="$route.name === 'home'" class="arrow" @click.prevent="smoothTo('#main')" href="#"></a>
      </div>
    </div>
  </div>
</template>

<style scoped lang="stylus">
@import '../css/variables'

.header
  padding-top 70px
  @media mobile
    padding-top 50px

.header .column
  transition all 0.3s

.home-header
  .column
    @media mobile-up
      padding-top 50px
      padding-bottom 50px
</style>

<script>
import Menu from './Menu';

export default {
  data () {
    return {
      className: 'home',
      timer: null
    }
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler () {
        this.timer && clearTimeout(this.timer);
        if (this.$route.name === 'home') {
          this.timer = setTimeout(() => {this.className = 'home-header';}, 200);
        } else {
          this.timer = setTimeout(() => {this.className = 'small-header';}, 200);
        }
      }
    }
  },
  methods: {
    smoothTo (element) {
      document.querySelector(element).scrollIntoView({
        behavior: 'smooth'
      });
    }
  },
  mounted () {
    this.className = this.$route.name === 'home' ? 'home-header' : 'small-header';
  },
  components: {
    Menu
  },
}
</script>